import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-lost-my-pass',
	templateUrl: './lost-my-pass.component.html',
	styleUrls: ['./lost-my-pass.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class LostMyPassComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/lost-my-pass/lost-my-pass.component.ts